import styled, { css } from 'styled-components';
import InputMask from 'react-input-mask';
import { colors } from '../../../theme/colors';
import {
  FormContainer as Container,
  FormLabel as Label,
  FormError as ErrorText,
  formSizeStyles as sizeStyles,
} from '../../sharedFormStyles';

export { Container, Label, ErrorText };

const getSpacingSm = (props) => (props.theme && props.theme.spacing && props.theme.spacing.sm) || '8px';
const getSurfaceBg = (props) => (props.theme && props.theme.colors && props.theme.colors.surface && props.theme.colors.surface.background) || '#f0f0f0';
const getTextPrimary = (props) => (props.theme && props.theme.colors && props.theme.colors.text && props.theme.colors.text.primary) || (colors.text && colors.text.primary) || '#091b26';
const getTextSecondary = (props) => (props.theme && props.theme.colors && props.theme.colors.text && props.theme.colors.text.secondary) || '#666';
const getTextMuted = (props) => (props.theme && props.theme.colors && props.theme.colors.text && props.theme.colors.text.muted) || '#999';
const getBrandPrimary = (props) => (props.theme && props.theme.colors && props.theme.colors.brand && props.theme.colors.brand.primary) || colors.brandDarkBlue;
const getFontFamily = (props) => (props.theme && props.theme.typography && props.theme.typography.fontFamily && props.theme.typography.fontFamily.base) || 'inherit';

export const shapeStyles = {
  rectangle: css`border-radius: 6px;`,
  rounded: css`border-radius: 50px;`,
};

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${(props) => (props.hasError ? colors.error : '#e0e0e0')};
  ${(props) => shapeStyles[props.shape] || shapeStyles.rectangle}
  background-color: ${(props) => (props.disabled ? colors.brandOffWhite : '#ffffff')};
  transition: border-color 0.2s, box-shadow 0.2s;
  width: 100%;
  padding: 0 ${props => getSpacingSm(props)};

  &:hover {
    ${(props) => !props.disabled && `
      border-color: ${props.hasError ? colors.error : '#b5b5b5'};
    `}
  }

  &:focus-within {
    ${(props) => !props.disabled && `
      border-color: ${props.hasError ? colors.error : colors.brandLightBlue};
      box-shadow: 0 0 0 3px ${props.hasError ? 'rgba(220, 53, 69, 0.25)' : 'rgba(0, 169, 255, 0.25)'};
    `}
  }

  ${(props) => props.disabled && `
    border-color: ${getSurfaceBg(props)};
    cursor: not-allowed;
  `}
`;

export const sharedInputStyles = css`
  flex: 1;
  border: none;
  background-color: transparent;
  width: 100%;
  box-sizing: border-box;
  color: ${props => getTextPrimary(props)};
  outline: none;
  padding-left: 4px;
  font-family: ${props => getFontFamily(props)};

  ${(props) => sizeStyles[props.size] || sizeStyles.md}

  &::placeholder {
    color: ${props => getTextSecondary(props)};
  }

  &:focus {
    outline: none;
  }

  &:not(:placeholder-shown) {
    color: ${props => getTextPrimary(props)};
  }

  &:disabled {
    cursor: not-allowed;
    color: ${props => getTextSecondary(props)};
    &::placeholder {
      color: ${props => getTextMuted(props)};
    }
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover, 
  &:-webkit-autofill:focus, 
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px ${(props) => (props.disabled ? colors.brandOffWhite : '#ffffff')} inset !important;
    -webkit-text-fill-color: ${props => getTextPrimary(props)} !important;
    transition: background-color 5000s ease-in-out 0s;
  }
`;

export const StyledInput = styled.input`
  ${sharedInputStyles}
`;

export const StyledInputMask = styled(InputMask)`
  ${sharedInputStyles}
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.hasError ? colors.error : colors.brandMediumGray)};
  margin-${(props) => (props.position === 'left' ? 'right' : 'left')}: ${props => getSpacingSm(props)};
  
  ${(props) => props.onClick && !props.disabled && css`
    cursor: pointer;
    &:hover {
      color: ${getBrandPrimary(props)};
    }
  `}

  ${(props) => props.disabled && css`
    color: ${getTextMuted(props)};
  `}
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Input/components/InputStyles.js